import bridge from '@vkontakte/vk-bridge';

function launchParams() {
  const fromSearch = new URLSearchParams(window.location.search);
  if (fromSearch.has('vk_app_id')) {
    return fromSearch;
  }
  const hash = window.location.hash.replace(/^#/, '');
  if (!hash) {
    return fromSearch;
  }
  const fromHash = new URLSearchParams(hash);
  return fromHash.has('vk_app_id') ? fromHash : fromSearch;
}

export function isVkMiniAppLaunch() {
  return launchParams().has('vk_app_id');
}

/** Required in VK iframe before the host hides its loading shell. */
export async function initVkMiniAppShell() {
  if (!isVkMiniAppLaunch()) {
    return;
  }
  await bridge.send('VKWebAppInit', {});
}

/** Tell VK the UI is ready (removes VK Games loading overlay). */
export async function signalVkMiniAppReady() {
  if (!isVkMiniAppLaunch()) {
    return;
  }
  await bridge.send('VKWebAppReady', {});
}
